import { Col, Divider, Image, Row } from 'antd';
import CommonFormAnt from 'commons/Forms/CommonFormAnt';
import {
    commonElement,
    commonInput,
    commonInputRows
} from 'commons/Forms/formsComponents/formTypes';
import { AuthContext } from 'context/auth';
import React, { useContext } from 'react';
import ServiceUser from 'services/user';
//import { ReactComponent as Logo } from 'images/logo-pc.svg';
import logoImg from 'images/logo.png';
import { Link, useNavigate } from 'react-router-dom';
import ServiceAuth from 'services/auth';
import { openNotification } from 'commons/Notifications';


const formFields: Array<commonInput | commonInputRows | commonElement> = [
    {
        type: 'string', // "email",
        name: 'name',
        label: 'Nome',
        placeholder: 'Nome',
    },
    {
        type: 'string', // "email",
        name: 'surname',
        label: 'Cognome',
        placeholder: 'Cognome',
    },
    {
        type: 'string', // "email",
        name: 'email',
        label: 'Email',
        placeholder: 'Email',
    },
    {
        type: 'password',
        name: 'password',
        label: 'Password',
        placeholder: 'Password',
    },
    {
        type: 'radio',
        label: 'Tipo utente',
        name: 'type',
        showAsButtons: true,
        options: [
            { label: 'Pubblico', value: 1 },
            { label: 'Privato', value: 2 },
        ],
    },
    {
        type: 'string', // "email",
        name: 'company',
        label: 'Ente di appartenenza',
        placeholder: 'Ente',
        conditions: {
            visibleIf: {
                name: 'type',
                value: 1,
            },
        },
    },
];

const SignupForm = (props) => {

    const navigate = useNavigate();

    const doSignup = async (data) => {

        ServiceAuth.signup(data)
            .then(async (response) => {
                openNotification({
                    message: 'OK',
                    description: 'Registrazione avvenuta correttamente procedere con la login',
                    type: 'success',
                });
                navigate("/", { replace: true })
            });
    };

    return (
        <Row justify="space-around" align="middle">
            <Col span={8} style={{ margin: '6% auto', textAlign: 'center' }}>
                <Image src={logoImg} />
                <section className="appLogin">
                    <h1><strong>CREA - REGISTRAZIONE UTENTE</strong></h1>
                    <h3 dangerouslySetInnerHTML={{
                        __html: "Sistema progettazione aree verdi"
                    }} />
                    <Divider />
                    <CommonFormAnt
                        autocomplete={true}
                        fields={formFields}
                        onSubmit={(data) => doSignup(data)}
                        submitText="Registrati"
                        submitOnEnterKey
                    />
                </section>
                <p className="additional-info">
                    Torna alla <Link to="/">Login</Link>
                </p>
            </Col>
        </Row>

    );
};

export default SignupForm;
